var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMarksV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.21 13.27q-.37-.45-.09-.68l.62-.5q.33-.26.78.23.27.3.94.82t1.75.52q1.41 0 2.13-.8.72-.78.72-2.08 0-1.22-.61-1.93-.62-.7-1.84-.7-.76 0-1.27.13t-1.05.56q-.37.3-.79.3h-.47q-.44 0-.44-.4V2.4q0-.4.44-.4h6.83q.45 0 .45.4v.67q0 .4-.45.4H7.33V7q0 .27-.02.54h.04q.55-.42 1.3-.58.74-.16 1.37-.16 1.85 0 2.91 1.1A4 4 0 0 1 14 10.83q0 1.96-1.29 3.07A5 5 0 0 1 9.23 15a5 5 0 0 1-4.02-1.73M14.18 16.52q-.18 0-.18-.18v-.37q0-.13.1-.29l2.23-3.53q.1-.15.23-.15h.37q.2 0 .19.19v3.65h.7q.18 0 .18.19v.3q0 .2-.18.2h-.7v1.28q0 .2-.18.19h-.35q-.2 0-.19-.19v-1.28zm.55-.68h1.67v-2.4l.01-.24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarksV2);
export default ForwardRef;